import { LoadingCardsComponent } from './loading-cards/loading-cards.component';
import { SearchInputComponent } from './search-input/search-input.component';
import { ActionMenuComponent } from './action-menu/action-menu.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { NgModule } from '@angular/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DynamicDialogModule, DialogService } from 'primeng/dynamicdialog';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { PasswordModule } from 'primeng/password';
import { PopoverModule } from 'primeng/popover';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SelectModule } from 'primeng/select';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { TagModule } from 'primeng/tag';
import { TextareaModule } from 'primeng/textarea';
import { TimelineModule } from 'primeng/timeline';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';

const PRIME_NG_MODULES = [
  AutoCompleteModule, AvatarModule, ButtonModule, CardModule, ChartModule, CheckboxModule,
  ChipModule, ConfirmDialogModule, DatePickerModule, DialogModule, DividerModule,
  DynamicDialogModule, IconFieldModule, InputIconModule, InputNumberModule, InputTextModule,
  MenuModule, PasswordModule, PopoverModule, ProgressSpinnerModule, SelectModule, SkeletonModule,
  TableModule, TabsModule, TagModule, TextareaModule, TimelineModule, ToastModule, TooltipModule
];

@NgModule({
  imports: [...PRIME_NG_MODULES, SearchInputComponent, ActionMenuComponent, PageHeaderComponent, EmptyStateComponent, LoadingCardsComponent],
  exports: [...PRIME_NG_MODULES, SearchInputComponent, ActionMenuComponent, PageHeaderComponent, EmptyStateComponent, LoadingCardsComponent],
  providers: [
    DialogService,
    ConfirmationService,
    MessageService
  ]
})
export class SharedPrimeNgModule {}
